import React from 'react'
import { getHexColor, OneColorIconProps } from '../utils'

export const NewsIcon: React.FC<OneColorIconProps> = ({ color = 'white', className, size }) => {
  const hexColor = getHexColor(color)
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
      className={className}
    >
      <path
        d="M5 21.874C4.45 21.874 3.97917 21.6782 3.5875 21.2865C3.19583 20.8949 3 20.424 3 19.874V5.87402C3 5.32402 3.19583 4.85319 3.5875 4.46152C3.97917 4.06986 4.45 3.87402 5 3.87402H16L21 8.87402V19.874C21 20.424 20.8042 20.8949 20.4125 21.2865C20.0208 21.6782 19.55 21.874 19 21.874H5ZM5 19.874H19V9.87402H15V5.87402H5V19.874ZM7 17.874H17V15.874H7V17.874ZM7 9.87402H12V7.87402H7V9.87402ZM7 13.874H17V11.874H7V13.874Z"
        fill={hexColor}
      />
    </svg>
  )
}
